import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Company } from '@models/company.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private readonly http = inject(HttpClient);

  private readonly ENDPOINT = 'companies';

  getAll(): Observable<Company[]> {
    return this.http.get<Company[]>(`${environment.apiBaseUrl}/${this.ENDPOINT}`);
  }

  create(company: Pick<Company, 'name'>): Observable<Company> {
    const body = {company: {id: null, name: company.name}};
    return this.http.post<{ company: Company }>(`${environment.apiBaseUrl}/${this.ENDPOINT}`, body)
      .pipe(map(res => res.company));
  }

  update(company: Pick<Company, 'id' | 'name'>): Observable<Company> {
    const body = {company: {id: company.id, name: company.name}};
    return this.http.patch<{ company: Company }>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${company.id}`, body)
      .pipe(map(res => res.company));
  }

  delete(id: string): Observable<string> {
    return this.http.delete<string>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${id}`);
  }
}
